export default __webpack_public_path__ + "static/media/about2.a8e7c1b1.png";